
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/student/appointments",
      function () {
        return require("private-next-pages/student/appointments.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/student/appointments"])
      });
    }
  